import React, { useEffect, useState } from "react";
import AppHeader from "../layout/AppHeader";
import CandidateList from "../components/CandidateList/CandidateList";
import { fetchAssignedCandidates } from "../api/candidateApi";
import { fetchCandidateJwtKey } from "../api/candidateApi";
import CandidateInfoHeader from "../components/CandidateInfoHeader/CandidateInfoHeader";
import DashboardContent from "../dashboard/DashboardContent";
import { fetchCurrentEmployee } from "../api/candidateApi";
import "./DashboardPage.css";
function DashboardPage() {
  const [candidates, setCandidates] = useState([]);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [jwtKeyData, setJwtKeyData] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [employeeId, setEmployeeId] = useState(null);

  useEffect(() => {
    fetchAssignedCandidates()
      .then((res) => {
        setCandidates(res.data);
      })
      .catch((err) => console.error("Error loading candidates:", err));
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const idFromUrl = Number(params.get("candidateId"));

    if (idFromUrl && candidates.length > 0) {

      const candidate = candidates.find(c => c.id === idFromUrl);

      if (candidate) {
        setSelectedCandidate(candidate);
      }
    }
  }, [candidates]);

  useEffect(() => {
    if (selectedCandidate) {
      fetchCandidateJwtKey(selectedCandidate.id)
        .then((res) => setJwtKeyData(res.data));
    }
  }, [selectedCandidate]);

  useEffect(() => {
    fetchCurrentEmployee()
      .then((res) => setEmployeeId(res.data.id))
      .catch((err) => console.error("Error fetching employee data:", err));
  }, []);



async function copyToClipboard() {
  if (!jwtKeyData?.jwtKey) return;

  try {
    await navigator.clipboard.writeText(jwtKeyData.jwtKey);
    alert("JWT Key copied!");
  } catch (error) {
    console.error("Clipboard API failed:", error);

    // ---- FALLBACK for macOS / blocked browsers ----
    const textarea = document.createElement("textarea");
    textarea.value = jwtKeyData.jwtKey;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    textarea.remove();

    alert("JWT Key copied! (Fallback method)");
  }
}


  return (
    <>
      <AppHeader />

      {selectedCandidate === null ? (
        // ===========================
        // FIRST SCREEN: CANDIDATE LIST
        // ===========================
        <CandidateList
          candidates={candidates}
          onSelect={(candidate) => {
            setSelectedCandidate(candidate);
            window.history.pushState({}, "", `/dashboard?candidateId=${candidate.id}`);
          }} />

      ) : !jwtKeyData ? (
        // ===========================
        // LOADING SCREEN
        // ===========================
        <p>Loading candidate data...</p>

      ) : (
        // ===========================
        // SELECTED CANDIDATE SCREEN
        // ===========================
        // ===========================
        // SELECTED CANDIDATE SCREEN
        // ===========================
        // <>
        //   {/* BACK BUTTON */}
        //   <button
        //     className="back-btn"
        //     onClick={() => {
        //       setSelectedCandidate(null);
        //       window.history.pushState({}, "", "/dashboard");
        //     }}
        //     style={{
        //       margin: "15px 0 10px 20px",
        //       padding: "6px 14px",
        //       background: "#f1f3f5",
        //       color: "#333",
        //       border: "1px solid #d0d5da",
        //       borderRadius: "6px",
        //       cursor: "pointer",
        //     }}
        //   >
        //     ← Back
        //   </button>

        //   <CandidateInfoHeader
        //     name={jwtKeyData.username}
        //     email={selectedCandidate.email}
        //     maskedJwt={isVisible ? jwtKeyData.jwtKey : "•".repeat(40)}
        //     isVisible={isVisible}
        //     onToggle={() => setIsVisible(!isVisible)}
        //     onCopy={copyToClipboard}
        //   />

        //   {employeeId ? (
        //     <DashboardContent
        //       candidateId={selectedCandidate.id}
        //       employeeId={employeeId}
        //     />
        //   ) : (
        //     <p>Loading employee info...</p>
        //   )}
        // </>


        <>
          <CandidateInfoHeader
            name={jwtKeyData.username}
            email={selectedCandidate.email}
            maskedJwt={isVisible ? jwtKeyData.jwtKey : "•".repeat(40)}
            isVisible={isVisible}
            onToggle={() => setIsVisible(!isVisible)}
            onCopy={copyToClipboard}
          />
          <div className="back-button-bar">
            <button
              className="back-btn"
              onClick={() => {
                setSelectedCandidate(null);
                window.history.pushState({}, "", "/dashboard");
              }}
            >
              ← Back
            </button>
          </div>

          {employeeId ? (
            <DashboardContent
              candidateId={selectedCandidate.id}
              employeeId={employeeId}
            />
          ) : (
            <p>Loading employee info...</p>
          )}
        </>


      )}
    </>
  );
}

export default DashboardPage;
